export const templateCafe = {

config:{
cor_primaria:"#3b2f2f"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"CAFETERIA",
pos_x:90,
pos_y:40,
estilo:{fontSize:30,color:"#f1c40f"}
},

{
id:2,
tipo:"texto",
conteudo:"ESPRESSO",
pos_x:30,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
},

{
id:3,
tipo:"texto",
conteudo:"R$ 6",
pos_x:260,
pos_y:180,
estilo:{fontSize:16,color:"#f1c40f"}
}

]

};